import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="smallchat"
export default class extends Controller {
  connect() {
    this.removeWidget()

    window.Smallchat = {
      config: {
        "slackTeamId": "T08MFML176F",
        "scChannelId": "-ONN0aj0CgID8GOGvoTY",
        "slackChannelId": "C08MF190868",
        "uid": "-ONN0WEltSngiy4BAd15",
        "planId": null,
        "accountCreated": 1744159773820
      },
      appearance: {
        "brand_color": "#10b77f",
        "contact_dismissible": true,
        "contact_enabled": true,
        "contact_field_label": "Email or phone number",
        "contact_immediately": false,
        "contact_prompt": "Add your name and email to make sure you see our reply:",
        "contact_reply": "Thanks {{name}}! You'll get a response here or we'll contact you at {{contact}}.",
        "custom_css": "",
        "hide_logo": false,
        "hide_team_icon": false,
        "launcher_pos": "right",
        "launcher_prompt": "Need help?",
        "launcher_type": "button",
        "messenger_blank": "Send a message, and we’ll reply as soon as we can.",
        "messenger_entry": "Send a message...",
        "messenger_prompt": "How can we help you?",
        "name_field_label": "Name",
        "offline_greeting": "We’re offline right now but typically respond in about an hour.",
        "text_color": "#FFFFFF"
      },
    };

    this.styles = document.createElement("link")
    this.styles.rel = "stylesheet"
    this.styles.href = "https://static.small.chat/messenger.css"
    this.styles.dataset.smallchatAsset = "true"
    document.head.appendChild(this.styles)

    this.script = document.createElement("script")
    this.script.async = true
    this.script.src = "https://static.small.chat/messenger.js"
    this.script.dataset.smallchatAsset = "true"
    document.body.appendChild(this.script)
  }

  disconnect() {
    this.removeWidget()
  }

  removeWidget() {
    document.querySelector("#Smallchat")?.remove()
    document.querySelectorAll("[data-smallchat-asset]").forEach((asset) => asset.remove())
  }
}
